export default defineNuxtPlugin(() => {
    const { principal, authentication } = usePrincipal();

    window.$crisp = [];
    window.CRISP_WEBSITE_ID = "0c5b1a19-7504-451b-8dd7-5f1483c91472";
    (function () {
        const d = document;
        const s = d.createElement("script");
        s.src = "https://client.crisp.chat/l.js";
        s.async = true;
        d.getElementsByTagName("head")[0].appendChild(s);
    })();

    watch(
        () => principal.value,
        (newPrincipal) => {
            if (newPrincipal && newPrincipal.user_id) {
                if (newPrincipal.email) {
                    window.$crisp.push(["set", "user:email", newPrincipal.email]);
                }

                window.$crisp.push(["set", "user:nickname", `${newPrincipal.user_id}`]);
            } else {
                window.$crisp.push(["do", "session:reset"]);
            }
        },
    );

    watch(
        () => authentication.value,
        () => {
            if (!authentication.value.authenticated) {
                window.$crisp.push(["do", "session:reset"]);
            }
        },
    );
});
